import store from "./player-store"
import { progressBar } from "./selectors"
import { getSlideContainerWidth } from "./dimensions"

const filmstrip = $("#filmstrip")
const filmstripList = $("#filmstrip-list")
const filmstripLens = $(".filmstrip-lens")
const filmstripLensImage = $(".filmstrip-lens-image")

const THUMB_MARGIN = 4

const getCursorRelativeLeftOffset = (event) => {
  return Math.max(0, event.pageX - progressBar.offset().left)
}

const updateFilmStripLens = (position) => {
  const index = position - 1

  const updatedImageUrl = $(".filmstrip-thumb")[index].src
  const isTopClip = Boolean(store.clipping.topClips.find((clip) => parseInt(clip.position, 10) === index))

  if (updatedImageUrl) {
    filmstripLens.toggleClass("top-clip", isTopClip)
    filmstripLensImage.attr("src", updatedImageUrl)
  }
}

const getBaseLeftOffset = () => {
  return getSlideContainerWidth() / 2 - THUMB_MARGIN
}

const calcMoveByRatio = () => {
  return Math.abs(filmstripList.width() / getSlideContainerWidth())
}

const getCursorSlidePosition = (event) => {
  return Math.max(1, Math.ceil((getCursorRelativeLeftOffset(event) / getSlideContainerWidth()) * store.totalSlides))
}

const moveFilmstrip = (event) => {
  const cursorRelativeLeftOffset = getCursorRelativeLeftOffset(event)
  const cursorSlidePosition = getCursorSlidePosition(event)
  const moveByOffset = getBaseLeftOffset() - cursorRelativeLeftOffset * calcMoveByRatio()

  updateFilmStripLens(cursorSlidePosition)
  filmstripList.css("marginLeft", moveByOffset)
}

const bindEventListeners = () => {
  progressBar.on("mouseenter", function (e) {
    filmstrip.css("display", "flex")
  })

  progressBar.on("mousemove", function (e) {
    moveFilmstrip(e)
  })

  progressBar.on("mouseleave", function () {
    filmstrip.hide()
  })
}

export const initializeFilmstrip = () => {
  if (filmstrip.length > 0) {
    bindEventListeners()
  }
}
